<template>
  <div class="t-sort" v-click-outside="closeList">
    <div class="t-sort__head" @click="toggleList">
      <p v-if="active" class="t-sort__label _active">{{ active.name }}</p>
      <p v-else class="t-sort__label">Сортировать по</p>
      <svg
        :style="showList ? 'transform: rotate(180deg)' : ''"
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.17327 12.6406C5.53776 12.2761 6.12871 12.2761 6.4932 12.6406L13.9999 20.1473L21.5066 12.6406C21.8711 12.2761 22.4621 12.2761 22.8265 12.6406C23.191 13.005 23.191 13.596 22.8265 13.9605L14.6599 22.1272C14.2954 22.4916 13.7044 22.4916 13.3399 22.1272L5.17327 13.9605C4.80878 13.596 4.80878 13.005 5.17327 12.6406Z"
          :fill="active ? '#293045' : '#C0C0CC'"
        />
      </svg>
    </div>
    <transition name="fade">
      <ul class="t-sort__list" v-if="showList">
        <li class="t-sort__item" v-for="(item, index) in list" :key="index" @click="setActiveItem(item)">
          {{ item.name }}
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'sort',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showList: false,
      active: null,
    }
  },
  methods: {
    closeList() {
      this.showList = false
    },
    toggleList() {
      this.showList = !this.showList
    },
    setActiveItem(item) {
      this.active = item
      this.closeList()

      let query = {}
      query['sort'] = item ? item.id : undefined

      this.routerPush(query)
    },
    routerPush(query) {
      this.$router
        .push({
          name: this.$route.name,
          query: Object.assign({}, this.$route.query, query),
        })
        .catch(err => {})
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/templates/components/ui-components/sort/sort.vue